<template>
  <div class="cardAppss" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="data">
      <h2>{{setData.scenic}}</h2>
      <ul>
        <li>
          <span>当天总数</span>
          <font>{{setData.day}}</font>
        </li>
        <li>
          <span>本月总数</span>
          <font>{{setData.month}}</font>
        </li>
        <li>
          <span>入园总数</span>
          <font>{{setData.total}}</font>
        </li>
      </ul>
    </div>

    <div class="user">
      <h2>入园会员信息</h2>
      <ul>
        <li v-for="(item,i) in setData.rs">
          <div :class="item.isvip == 1 ? 'isuservip':''">
            <img :src="item.avatar" />
            <div class="info">
              <div class="A1">
                <span>{{item.username}}</span>
                <span>{{item.createtime}}</span>
              </div>
              <div class="A2">手机号:{{item.phone}}</div>
              <div class="A2">身份证号:{{item.idCard}}</div>
              <div v-if="setData.istoo == 1" class="A2" style="color:green;font-weight:bold">订单编号:{{item.number}}</div>
              <div v-if="setData.istoo == 1" class="A2" style="color:green;font-weight:bold">支付金额: {{item.price}}元</div>
            </div>
            <font v-if="item.isvip == 1">VIP</font>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        setData:[],
      };
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.ryUser();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      ryUser:function(){
        var id = this.$route.query.id
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/useCardData',
          params:{
            id:id
          }
        }).then(function(response){
          that.setData = response.data.data;
        }).catch(err=>{

        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .cardAppss{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
    padding-top:3%
  }
  .cardAppss .data{
    width:94%;
    display:block;
    margin:0 auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
  }
  .cardAppss .data h2{
    font-size:16px;
    padding:10px 0;
    letter-spacing:1px;
    width:92%;
    margin:0 auto
  }
  .cardAppss .data ul{
    width:92%;
    margin:0 auto
  }
  .cardAppss .data li{
    height:40px;
    border-bottom:1px solid #EBF2FF;
    line-height:40px;
  }
  .cardAppss .data li:last-child{
    border-bottom:none;
  }
  .cardAppss .data li span{
    float:left;
    width:30%;
    margin-left:2%;
    font-size:15px;
    letter-spacing:1px;
    color:#555
  }
  .cardAppss .data li font{
    float:right;
    width:50%;
    text-align:right;
    margin-right:2%;
    font-size:15px;
    letter-spacing:1px;
    font-weight:500;
    color:#007aff
  }
  .cardAppss .user{
    width:94%;
    display:block;
    margin:0 auto;
  }
  .cardAppss .user h2{
    font-size:16px;
    padding:25px 0 15px 0;
    letter-spacing:1px;
  }
  .cardAppss .user ul{
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius: 10px;
    background:#fff;
  }
  .cardAppss .user li{
    border-bottom:solid 1px #EBF2FF;
    width:92%;
    margin:0 auto;
  }
  .cardAppss .user li img{
    float:left;
    width:70px;
    height:70px;
    margin:15px 5px 10px 0px;
    border-radius:50%;
  }
  .cardAppss .user li:after,.cardAppss .user li .isuservip:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .cardAppss .user li .info{
    float:left;
    width:75%;
    margin-top:10px
  }
  .cardAppss .user li .info .A1{
    font-size:15px;
    padding-bottom:7px;
    height:20px
  }
  .cardAppss .user li .info .A1 span:last-child{
    font-size:14px;
    float:right;
    color:#555;
    margin-top:3px
  }

  .cardAppss .user li .info .A1 span:first-child{
    float:left;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    width:45%
  }
  .cardAppss .user li .info .A2{
    font-size:14px;
    padding-bottom:5px;
    color:#999;
  }

  .cardAppss .user li .isuservip{
    border:2px dashed #ffd700;
    margin:15px 0;
    border-radius:6px;
    position:relative;
    float:left;
    width:98%;
    padding-left:2%
  }
  .cardAppss .user li .isuservip font{
    position:absolute;
    top:-10px;
    right:-10px;
    color:#f00;
    font-weight:bold;
    border:2px dashed #ffd700;
    border-radius: 50%;
    width:23px;
    height:23px;
    background:#fff;
    font-size:12px;
    line-height:23px;
    text-align:center
  }
</style>